import React from "react"

import { NotificationManager } from "react-notifications"

import { gql, useMutation } from "hooks/urql"

export type ResolveButtonProps = {
  id: string
  resolved: boolean
}

const ResolveButton: React.FC<ResolveButtonProps> = ({ id, resolved }) => {
  const [, runMutation]: any[] = useMutation(resolveMessageMutation)

  const resolveMessage = () => {
    runMutation({ messageId: id, resolve: !resolved })
      .then(
        result => {
          const { failures } = result.data.resolveMessage
          if (failures.length > 0) {
            NotificationManager.error(failures[0].message)
          } else {
            NotificationManager.success(
              `This message has been ${resolved ? "unresolved" : "resolved"}`
            )
          }
        },
        () => NotificationManager.error("Something went wrong")
      )
      .catch(() => NotificationManager.error("Something went wrong"))
  }

  return (
    <button className="btn btn-success btn-sm" onClick={resolveMessage}>
      {resolved ? "Unresolve" : "Resolve"}
    </button>
  )
}

const resolveMessageMutation = gql`
  mutation Resolve($messageId: ID!, $resolve: Boolean!) {
    resolveMessage(messageId: $messageId, resolve: $resolve) {
      failures {
        message
      }
      message {
        id
      }
    }
  }
`

export default ResolveButton
